// hero slideshow
(function(){
let h=document.querySelector('.hero-slider');
if(!h)return;
let slides=[...h.querySelectorAll('.slide')];
if(slides.length<2)return;
let dots=h.querySelector('.slider-dots');
let prev=h.querySelector('.slider-prev');
let next=h.querySelector('.slider-next');
let cur=0,timer;

let d=[];
slides.forEach((_,i)=>{let b=document.createElement('button');b.className=i===0?'on':'';b.onclick=()=>go(i);dots.appendChild(b);d.push(b);});

function loadVid(slide,play){
let v=slide.querySelector('.slide-vid');
if(!v)return;
if(!v.dataset.loaded){
let u=(window.innerWidth<=650&&v.dataset.sd)?v.dataset.sd:v.dataset.hd;
if(u){v.src=u;v.dataset.loaded=1;}
}
if(play){let p=v.play();if(p&&p.catch)p.catch(function(){});}
}
function manage(i){
slides.forEach(function(s,j){
let v=s.querySelector('.slide-vid');
if(!v)return;
if(j===i){loadVid(s,true);}else{v.pause();}
});
}
function go(i){
if(!slides[i])return;
slides.forEach(s=>s.classList.remove('active'));
slides[i].classList.add('active');
d.forEach((b,j)=>b.classList.toggle('on',j===i));
cur=i;
manage(i);
setTimeout(function(){loadVid(slides[(i+1)%slides.length],false);},2500);
}
function auto(){timer=setInterval(()=>go((cur+1)%slides.length),9000)}
function stop(){clearInterval(timer)}
prev.onclick=()=>{stop();go((cur-1+slides.length)%slides.length);auto()};
next.onclick=()=>{stop();go((cur+1)%slides.length);auto()};
h.addEventListener('mouseenter',stop);
h.addEventListener('mouseleave',auto);
auto();
})();

// transparent header -> solid on scroll (homepage)
(function(){
let head=document.querySelector('body.hp header');
if(!head)return;
let sl=document.querySelector('.hero-slider');
let onScroll=()=>{
let top=sl?sl.getBoundingClientRect().bottom:0;
head.classList.toggle('scrolled',top<80);
};
onScroll();
window.addEventListener('scroll',onScroll,{passive:true});
})();

// favourites (localStorage wishlist)
(function(){
let KEY='xtore_favs';
function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}}
function set(a){localStorage.setItem(KEY,JSON.stringify(a));sync();}
function sync(){
let a=get();
document.querySelectorAll('#fav-count').forEach(e=>e.textContent=a.length);
document.querySelectorAll('.fav').forEach(b=>{
let id=String(b.dataset.favId);
b.classList.toggle('on',a.some(f=>String(f.id)===id));
});
}
function render(){
let a=get();
let el=document.getElementById('fav-list');
if(!el)return;
document.getElementById('fav-drawer-count').textContent=a.length;
if(!a.length){el.innerHTML='<div class="favempty">No saved items yet.<br>Tap the &#9829; on any product to keep it here.</div>';return;}
el.innerHTML=a.map(f=>`<div class="favrow">
<a href="${f.url}"><img src="${f.img||''}" alt=""></a>
<div><a class="n" href="${f.url}">${f.title}</a><span class="p">${f.price||''}</span></div>
<button class="rm" data-fav-id="${f.id}" aria-label="Remove">&#10005;</button>
</div>`).join('');
el.querySelectorAll('.rm').forEach(b=>b.onclick=()=>{
let id=b.dataset.favId;
set(get().filter(f=>String(f.id)!==String(id)));
render();
});
}
function toggle(id){
let a=get();
let i=a.findIndex(f=>String(f.id)===String(id));
if(i>=0){a.splice(i,1);}
else{
let b=document.querySelector(`.fav[data-fav-id="${id}"]`);
if(b){
a.push({id:id,title:b.dataset.favTitle,price:b.dataset.favPrice,img:b.dataset.favImg,url:b.dataset.favUrl});
}
}
set(a);
}
document.addEventListener('click',e=>{
let b=e.target.closest('.fav');
if(b){e.preventDefault();b.classList.toggle('on');toggle(b.dataset.favId);}
});
window.toggleFavDrawer=()=>{
document.getElementById('fav-drawer').classList.toggle('open');
document.getElementById('fav-mask').classList.toggle('open');
render();
};
window.closeFavDrawer=()=>{
document.getElementById('fav-drawer').classList.remove('open');
document.getElementById('fav-mask').classList.remove('open');
};
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeFavDrawer();});
sync();
})();

// ---- footer localization dropdowns (amazon-style) ----
(function(){
let groups=[...document.querySelectorAll('.loc-group')];
if(!groups.length)return;
groups.forEach(g=>{
let head=g.querySelector('.loc-head');
let menu=g.querySelector('.loc-menu');
if(!head||!menu)return;
head.addEventListener('click',e=>{
e.preventDefault();
let isOpen=g.classList.contains('open');
document.querySelectorAll('.loc-group.open').forEach(o=>o.classList.remove('open'));
if(!isOpen)g.classList.add('open');
});
});
document.addEventListener('click',e=>{
if(!e.target.closest('.loc-group'))document.querySelectorAll('.loc-group.open').forEach(o=>o.classList.remove('open'));
});
})();

function toast(t){
let x=document.getElementById('toast');
x.textContent=t;
x.style.display='block';
setTimeout(()=>x.style.display='none',2000)
}

document.querySelectorAll('[data-add]').forEach(b=>{
b.onclick=async()=>{
let old=b.textContent;
b.disabled=true;
b.textContent='\u2026';

try{
let r=await fetch('/cart/add.js',{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:[{id:Number(b.dataset.add),quantity:1}]})
});

if(!r.ok)throw 0;

await r.json();
toast('Added to cart');
setTimeout(()=>location.reload(),500);

}catch(e){
toast('Unable to add product');
b.disabled=false;
b.textContent=old;
}
}
});

(function(){
try{
if(!window.matchMedia)return;
if(!matchMedia('(hover:hover)').matches)return;
if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
var MAX=7;
document.querySelectorAll('.card').forEach(function(card){
var raf=null;
card.addEventListener('mousemove',function(e){
var r=card.getBoundingClientRect();
var px=(e.clientX-r.left)/r.width;
var py=(e.clientY-r.top)/r.height;
var ry=((px-.5)*2*MAX).toFixed(2)+'deg';
var rx=((.5-py)*2*MAX).toFixed(2)+'deg';
if(raf)cancelAnimationFrame(raf);
raf=requestAnimationFrame(function(){
card.style.setProperty('--rx',rx);
card.style.setProperty('--ry',ry);
});
},{passive:true});
card.addEventListener('mouseleave',function(){
if(raf)cancelAnimationFrame(raf);
card.style.setProperty('--rx','0deg');
card.style.setProperty('--ry','0deg');
});
});
}catch(e){}
})();

window.toggleMenu=function(){
var d=document.getElementById('menu-drawer');
var m=document.getElementById('menu-mask');
if(!d)return;
var open=d.classList.toggle('open');
m.classList.toggle('open',open);
d.setAttribute('aria-hidden',open?'false':'true');
var b=document.querySelector('.menu-btn');
if(b)b.setAttribute('aria-expanded',open?'true':'false');
};
window.closeMenu=function(){
var d=document.getElementById('menu-drawer');
var m=document.getElementById('menu-mask');
if(!d)return;
d.classList.remove('open');
m.classList.remove('open');
d.setAttribute('aria-hidden','true');
var b=document.querySelector('.menu-btn');
if(b)b.setAttribute('aria-expanded','false');
};
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeMenu();});

(function(){
var vs=document.querySelectorAll('.promo-vid,.na-vid');
if(!vs.length)return;
try{
if('IntersectionObserver' in window){
vs.forEach(function(v){
new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){v.play().catch(function(){});}else{v.pause();}});},{rootMargin:'200px'}).observe(v);
});
}
}catch(e){}
})();

(function(){
var row=document.querySelector('#products .products');
if(!row)return;
var id=null,speed=2;
function step(){
if(document.hidden)return;
var max=row.scrollWidth-row.clientWidth;
if(max<=0)return;
row.scrollLeft+=speed;
if(row.scrollLeft>=max){row.scrollLeft=0;}
}
function start(){if(!id)id=setInterval(step,25);}
function stop(){if(id){clearInterval(id);id=null;}}
row.addEventListener('touchstart',stop);
row.addEventListener('touchend',start);
start();
})();
;
(function(){
document.addEventListener('click',function(e){
var p=e.target.closest('.vpill');if(!p)return;
var i=p.querySelector('input');if(!i)return;
i.checked=true;
var box=p.closest('.varrow');if(!box)return;
var pills=box.querySelectorAll('.vpill');
for(var k=0;k<pills.length;k++)pills[k].classList.toggle('sel',pills[k]===p);
var f=p.closest('form');if(!f)return;
function pin(sel,attr){var n=f.querySelector(sel);if(n){var lbl=p.querySelector('span');if(lbl)n[attr]=lbl.textContent.trim();}}
pin('#pick-var2,.pcolor','textContent');
pin('.pname,.phere','textContent');
var vimg=p.getAttribute('data-vimg');
var vfull=p.getAttribute('data-vfull');
if(vimg){
  var main=document.getElementById('azMain');
  if(main)main.src=vimg;
  var zi=document.getElementById('azZoomImg');
  if(zi)zi.src=vfull||vimg;
  var ths=document.querySelectorAll('.az-thumb');
  for(var t=0;t<ths.length;t++){
    if(vfull&&ths[t].getAttribute('data-azfull')===vfull){ths[t].classList.add('on');}
    else{ths[t].classList.remove('on');}
  }
}
});
})();
;
(function(){
var PI=[].slice.call(document.querySelectorAll('.gmain img'));
var PU=[].slice.call(document.querySelectorAll('.gthumb'));
var LB=document.getElementById('lb');
function openLb(k){
if(!LB||!PI.length)return;
if(!LB.querySelector('img.limg')&&!LB.querySelector('.limg'))return;
var im=LB.querySelector('.limg')||LB.querySelector('img');
if(!im)return;
im.src=k<PI.length?PI[k].src:PI[0].src;
LB.hidden=false;
document.body.style.overflow='hidden';
}
function closeLb(){
if(!LB)return;
LB.hidden=true;
document.body.style.overflow='';
}
function mv(d){
if(!PI.length)return;
var cur=PI.indexOf(document.querySelector('.gmain img').src);
var n=(cur+d+PI.length)%PI.length;
openLb(n);
}
if(document.querySelector('.gmain img')){document.querySelector('.gmain img').addEventListener('click',function(){openLb(0);});}
for(var i=0;i<PU.length;i++){(function(b,d){b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openLb(d);});})(PU[i],i);}
var back=LB&&LB.querySelector('.lback');if(back)back.addEventListener('click',closeLb);
var card=LB&&LB.querySelector('.lcard');if(card)card.addEventListener('click',closeLb);
var fp=LB&&LB.querySelector('.lprev');if(fp)fp.addEventListener('click',function(){mv(-1);});
var fn=LB&&LB.querySelector('.lnext');if(fn)fn.addEventListener('click',function(){mv(1);});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLb();});
})();
;
/* ===== Amazon-style page helpers (Xtore) ===== */
(function(){
  // Amazon gallery: thumb click swaps main image; main click opens zoom
  (function(){
    var thumbs=[].slice.call(document.querySelectorAll('.az-thumb'));
    var stage=document.getElementById('azStage');
    var main=document.getElementById('azMain');
    var zoom=document.getElementById('azZoom');
    var zimg=document.getElementById('azZoomImg');
    if(!thumbs.length||!stage||!main)return;
    var cur=0;
    function full(i){var b=thumbs[i]&&thumbs[i].getAttribute('data-azfull');return b||thumbs[i].querySelector('img').src;}
    function pick(i){
      if(i<0||i>=thumbs.length)return;
      cur=i;
      main.src=full(i);
      thumbs.forEach(function(t,k){t.classList.toggle('on',k===i);});
    }
    function showZoom(k){
      if(k<0)k=thumbs.length-1;if(k>=thumbs.length)k=0;
      cur=k;if(zimg)zimg.src=full(k);
      if(zoom)zoom.hidden=false;
      document.body.style.overflow='hidden';
    }
    function hideZoom(){if(zoom)zoom.hidden=true;document.body.style.overflow='';}
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){pick(i);});});
    stage.addEventListener('click',function(){showZoom(cur);});
    var prev=document.querySelector('[data-azprev]');
    var next=document.querySelector('[data-aznext]');
    if(prev)prev.addEventListener('click',function(e){e.stopPropagation();showZoom(cur-1);});
    if(next)next.addEventListener('click',function(e){e.stopPropagation();showZoom(cur+1);});
    [].slice.call(document.querySelectorAll('[data-azzc]')).forEach(function(el){el.addEventListener('click',hideZoom);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')hideZoom();});
  })();

  // Customer-reviews filter (collection page)
  var stars=[].slice.call(document.querySelectorAll('.az-f-star'));
  var cards=[].slice.call(document.querySelectorAll('.az-card'));
  if(stars.length&&cards.length){
    function apply(){
      var min=0;
      stars.forEach(function(c){if(c.checked)min=Math.max(min,parseInt(c.dataset.min,10)||0);});
      cards.forEach(function(card){
        var r=parseInt(card.dataset.r,10)||0;
        card.style.display=(r>=min)?'':'none';
      });
    }
    stars.forEach(function(c){c.addEventListener('change',apply);});
  }

  // Buy Now (adds to cart then goes to checkout)
  [].slice.call(document.querySelectorAll('.az-buynow')).forEach(function(b){
    b.addEventListener('click',async function(){
      var f=b.closest('form');
      if(!f)return;
      var fd=new FormData(f);
      var vid=fd.get('id'),q=Number(fd.get('quantity'))||1;
      if(!vid){toast('Please choose options first');return;}
      if(window.__azBusy)return;
      window.__azBusy=true;
      b.textContent='Redirecting\u2026';
      try{
        var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:q}]})});
        if(!r.ok)throw 0;
        b.textContent='Buy Now';
        window.__azBusy=false;
        /* Signed in -> straight to payment. Signed out -> sign-in gate, item already in the cart. */
        if(document.body.getAttribute('data-xtg')==='in'){
          location.href='/checkout';
        }else if(window.xtgOpen){
          window.xtgOpen('Your item is saved in your cart. Sign in or create a free account to finish checkout.');
        }else{
          location.href='/cart';
        }
      }catch(e){toast('Unable to add product');b.textContent='Buy Now';window.__azBusy=false;}
    });
  });
})();
;
// ---- live search bar (footer Help > Search) ----
(function(){
var sbar=document.getElementById('sbar');
if(!sbar)return;
var input=document.getElementById('sbar-input');
var res=document.getElementById('sbar-results');
var timer=null;
function fmt(p){return '$'+Number(p).toFixed(2);}
function openSB(){
  sbar.classList.add('open');
  document.body.style.overflow='hidden';
  if(input){input.value='';res.innerHTML='';}
  setTimeout(function(){if(input)input.focus();},80);
}
function closeSB(){
  sbar.classList.remove('open');
  document.body.style.overflow='';
}
window.openSearchBar=openSB;
window.closeSearchBar=closeSB;
document.addEventListener('click',function(e){
  var t=e.target.closest('.search-open');
  if(t){e.preventDefault();openSB();}
});
sbar.addEventListener('click',function(e){if(e.target===sbar)closeSB();});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeSB();});
if(input)input.addEventListener('input',function(){
  clearTimeout(timer);
  var q=this.value.trim();
  if(q.length<2){res.innerHTML='';return;}
  timer=setTimeout(function(){run(q);},260);
});
function run(q){
  fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources%5Btype%5D=product&resources%5Blimit%5D=8').then(function(r){return r.json();}).then(function(d){
    var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
    if(!items.length){
      res.innerHTML='<div class="sbar-msg">No exact match found for "'+q.replace(/</g,'&lt;')+'" &mdash; try another word, or browse the categories. Many similar items may be available.</div>';
      return;
    }
    res.innerHTML='';
    items.forEach(function(p){
      var a=document.createElement('a');
      a.className='sres';
      a.href=p.url;
      var img=p.featured_image&&p.featured_image.url?p.featured_image.url.replace(/^https?:/,''):'';
      if(img){
        var ci=document.createElement('img');
        ci.src=img;ci.alt='';ci.loading='lazy';
        a.appendChild(ci);
      }
      var tx=document.createElement('span');
      tx.className='st';
      var b=document.createElement('b');
      b.textContent=p.title;
      var pr=document.createElement('em');
      pr.textContent=fmt(p.price);
      var st=document.createElement('span');
      st.className=p.available?'av':'na';
      st.textContent=p.available?'\u25CF In stock \u2014 ready to ship':'\u25CF Out of stock \u2014 similar styles available';
      tx.appendChild(b);tx.appendChild(pr);tx.appendChild(st);
      a.appendChild(tx);
      res.appendChild(a);
    });
  }).catch(function(){
    res.innerHTML='<div class="sbar-msg">Search is temporarily unavailable. Please try again.</div>';
  });
}
})();